// src/services/api/messageCenterSummaryReport.js
import { apiClient } from './base';

/**
 * Get filter options for the Message Center Summary report (active shift types + date presets)
 */
export const getMessageCenterSummaryFilters = async () => {
  try {
    const response = await apiClient.get('/message-center-summary/filters');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the 6 KPI summary cards for the selected date range
 * @param {Object} params - { dateFrom, dateTo }
 */
export const getMessageCenterSummaryKpis = async (params) => {
  try {
    const response = await apiClient.get('/message-center-summary/summary-cards', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get shift boxes, one per active shift type, aggregated across { dateFrom, dateTo }.
 * Without params the backend defaults to real calendar "today".
 */
export const getMessageCenterShiftTodayAchievement = async (params = {}) => {
  try {
    const response = await apiClient.get('/message-center-summary/today-shift', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the last 7 real days' achieved-vs-target series, one per active shift type.
 * Always trailing 7 real days — takes no date params.
 */
export const getMessageCenterShiftLast7DaysTrend = async () => {
  try {
    const response = await apiClient.get('/message-center-summary/last-7-days-achieved-target');
    return response.data;
  } catch (error) {
    throw error;
  }
};
